import React, { useState } from 'react';
import ExpandAll from '../ExpandAll/ExpandAll';
import './QuestionsSection.scss';

function QuestionsSection({ id, title, children }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { isSectionExpanded: isExpanded });
    }
    return child;
  });

  return (
    <div id={id} className="mn_questionsSection">
      <h3>{title} <ExpandAll isExpanded={isExpanded} setIsExpanded={setIsExpanded} /></h3>
      {childrenWithProps}
    </div>
  );
}

export default QuestionsSection;
